import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import {
  Button,
  Card,
  Col,
  Collapse,
  CollapseItem,
  Checkbox,
  Dialog,
  Row,
  Upload,
  Submenu,
  Menu,
  MenuItem,
  Loading,
  Container,
  Header,
  Main,
  Footer,
  Table,
  TableColumn,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Pagination,
  Steps,
  Step,
  TabPane,
  Tabs,
  Tooltip,
  Dropdown,
  DropdownMenu,
  RadioGroup,
  Divider,
  Radio,
  DropdownItem,
  DatePicker,
  Progress,
  InputNumber,
  Alert,
  RadioButton,
  OptionGroup,
  Tag
} from 'element-ui';

import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import App from './App';
import router from './router';
import messages from '@/utils/messages';
import './style/main.scss';
import './style/element-variables.scss';
import store from './store';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import carregarExtends from '@/utils/veeValidate';

import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

library.add(
  faSignOutAlt
);

// Adição de constantes
Vue.prototype.$messages = messages

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueToastr)

Vue.use(VueTheMask)
Vue.use(Card)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(Checkbox)
Vue.use(CollapseItem)
Vue.use(Dialog)
Vue.use(Row)
Vue.use(Upload)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Loading)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Button)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Tooltip)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(Checkbox)
Vue.use(Divider)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(DropdownItem)
Vue.use(Progress)
Vue.use(Tag)
Vue.use(Alert)
Vue.use(RadioButton)
Vue.use(OptionGroup)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

carregarExtends()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})